import styled from '@emotion/styled';
import { motion } from 'framer-motion';
export const MarketplaceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: white;
  
  .dark & {
    background: #1f2937;
  }
`;
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
  border-bottom: 1px solid #e5e7eb;
  
  .dark & {
    border-bottom: 1px solid #374151;
  }

  h1 {
    font-size: 2rem;
    font-weight: 700;
    color: #111827;
    margin: 0 0 0.5rem 0;
    
    .dark & {
      color: #f9fafb;
    }
  }

  p {
    font-size: 1rem;
    color: #6b7280;
    margin: 0;
    
    .dark & {
      color: #9ca3af;
    }
  }
`;
export const SearchSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e5e7eb;
  
  .dark & {
    border-bottom: 1px solid #374151;
  }

  .search-container {
    flex: 1;
    position: relative;
    
    .search-icon {
      position: absolute;
      left: 1rem;
      top: 50%;
      transform: translateY(-50%);
      color: #9ca3af;
      width: 1.25rem;
      height: 1.25rem;
    }
    
    input {
      width: 100%;
      padding: 0.75rem 1rem 0.75rem 3rem;
      border: 1px solid #d1d5db;
      border-radius: 0.5rem;
      font-size: 1rem;
      background: white;
      color: #111827;
      transition: border-color 0.2s;
      
      .dark & {
        background: #374151;
        border-color: #4b5563;
        color: #f9fafb;
      }
      
      &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }
      
      &::placeholder {
        color: #9ca3af;
      }
    }
  }

  .filter-controls {
    display: flex;
    gap: 1rem;
    
    select {
      padding: 0.5rem 1rem;
      border: 1px solid #d1d5db;
      border-radius: 0.375rem;
      background: white;
      color: #111827;
      font-size: 0.875rem;
      
      .dark & {
        background: #374151;
        border-color: #4b5563;
        color: #f9fafb;
      }
      
      &:focus {
        outline: none;
        border-color: #3b82f6;
      }
    }
  }
`;
export const CategoryTabs = styled.div`
  display: flex;
  gap: 0.25rem;
  padding: 1rem 2rem;
  border-bottom: 1px solid #e5e7eb;
  overflow-x: auto;
  
  .dark & {
    border-bottom: 1px solid #374151;
  }

  button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 0.375rem;
    background: transparent;
    color: #6b7280;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
    
    .dark & {
      color: #9ca3af;
    }
    
    &:hover {
      background: #f3f4f6;
      color: #374151;
      
      .dark & {
        background: #4b5563;
        color: #d1d5db;
      }
    }
    
    &.active {
      background: #3b82f6;
      color: white;
      
      .count {
        background: rgba(255, 255, 255, 0.2);
      }
    }
    
    .count {
      padding: 0.125rem 0.375rem;
      background: #e5e7eb;
      border-radius: 9999px;
      font-size: 0.75rem;
      
      .dark & {
        background: #4b5563;
      }
    }
  }
`;
export const ServerGrid = styled.div`
  flex: 1;
  padding: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 1.5rem;
  overflow-y: auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 1rem;
  }
`;
export const ServerCard = styled(motion.div)`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  background: white;
  transition: all 0.2s;
  
  .dark & {
    background: #374151;
    border-color: #4b5563;
  }
  
  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    
    .dark & {
      border-color: #60a5fa;
    }
  }
`;
export const ServerInfo = styled.div`
  flex: 1;
  
  .server-header {
    margin-bottom: 0.75rem;
    
    .server-title {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.25rem;
      
      h3 {
        font-size: 1.125rem;
        font-weight: 600;
        color: #111827;
        margin: 0;
        
        .dark & {
          color: #f9fafb;
        }
      }
    }
    
    .server-meta {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      font-size: 0.875rem;
      color: #6b7280;
      
      .dark & {
        color: #9ca3af;
      }
      
      .version {
        background: #dbeafe;
        color: #1e40af;
        padding: 0.125rem 0.5rem;
        border-radius: 9999px;
        font-weight: 500;
        
        .dark & {
          background: #1e3a8a;
          color: #93c5fd;
        }
      }
    }
  }
  
  .description {
    font-size: 0.875rem;
    color: #6b7280;
    line-height: 1.5;
    margin: 0 0 1rem 0;
    
    .dark & {
      color: #9ca3af;
    }
  }
  
  .capabilities {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    margin-bottom: 1rem;
    
    .capability {
      display: inline-block;
      padding: 0.125rem 0.5rem;
      font-size: 0.75rem;
      background: #f3f4f6;
      color: #374151;
      border-radius: 9999px;
      
      .dark & {
        background: #4b5563;
        color: #d1d5db;
      }
      
      &.more {
        background: #e5e7eb;
        color: #6b7280;
        
        .dark & {
          background: #374151;
          color: #9ca3af;
        }
      }
    }
  }
  
  .stats {
    display: flex;
    gap: 1rem;
    
    .stat {
      display: flex;
      align-items: center;
      gap: 0.25rem;
      font-size: 0.875rem;
      color: #6b7280;
      
      .dark & {
        color: #9ca3af;
      }
    }
  }
`;
export const ServerActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
  
  .dark & {
    border-top: 1px solid #4b5563;
  }
  
  .installed-actions {
    display: flex;
    gap: 0.5rem;
  }
  
  .external-links {
    display: flex;
    gap: 0.25rem;
  }
`;
export const FilterSection = styled.div`
  padding: 1rem 2rem;
  border-bottom: 1px solid #e5e7eb;
  
  .dark & {
    border-bottom: 1px solid #374151;
  }
`;
export const EmptyState = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  color: #9ca3af;
  
  svg {
    color: #d1d5db;
    margin-bottom: 1rem;
  }
  
  h3 {
    font-size: 1.125rem;
    font-weight: 600;
    margin: 0 0 0.5rem 0;
  }
  
  p {
    font-size: 0.875rem;
    margin: 0;
  }
`;
